module.exports = __webpack_public_path__ + "static/media/img002.5f010755.jpg";